//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import {requestByPost} from '@/util/request'
import {API} from '@/util/api'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
export default {
 name: 'societyArticleNewsDetail',
 data(){
    return {
      societyId: (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
      societyName: (this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'), //0显示平台头部按钮  1显示机构头部按钮,  //机构id
      newsInfo:'',//详情信息
      page: {
        pageNum: 0,
        pageSize: 5
      },
      societyArticleNewsList: [],
      showType:1,
      id: ''
    }
  },
 components:{
    Header,
    Footer
 },
 created () {
   let that = this;
   that.$store.commit('home/setShowMenuType', 1);//机构菜单
   that.$store.commit('home/setMenuJgActive', 4);
   that.id = that.$route.query.id
   that.fnDate(this.id)
   that.newsListPage()
 },
 updated(){
    //每个16:9的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*9/16);
    });
    
  },
  methods:{
    fnDate(id){
      let params = new Object();
      params.id = id
      requestByPost(API.selSocietyArticleNewsById,JSON.stringify(params))
        .then((res) => {
          this.newsInfo = res.data.obj
          this.fnOneOrTwo()
        })
    },
    newsListPage () {
      var params = {}
      if (this.societyId != null && this.societyId != undefined && this.societyId != '') {
        params.societyId = this.societyId
      }
      params.id = this.id
      params.page = this.page
      requestByPost(API.selSocietyArticleNewsPage,JSON.stringify(params))
        .then((res) => {
          this.societyArticleNewsList = res.data.otherList
          if (this.page.pageNum != 0 && this.societyArticleNewsList.length == 0) {
            this.page.pageNum = 0
            this.page.pageSize = 5
            this.newsListPage()
          }
        })
    },
    fnCompany (companyId) {
      this.$router.push({path: '/companyDetailNew', query: {companyId:companyId,inType:3}});
    },
    fnHyp () {
      this.page.pageSize = 5
      this.page.pageNum = this.page.pageNum + 1
      this.newsListPage()
    },
    goPlatIndex(){
      this.$router.push({path: '/home'});
    },
    goIndex () {
      this.$router.push({path: '/societyIndex', query: {societyId:this.societyId}});
    },
    goList () {
      this.$router.push({path: '/societyArticleNews', query: {societyId:this.societyId}});
    },
    goDetail (id) {
      this.$router.push({path: '/societyArticleNewsDetail', query: {id:id,societyId:this.societyId}});
    },
    //跳转到机构主页
    fnGoToSocietyIndexPage(e){
      this.fnStopBub(e);
      this.$router.push({path: '/societyIndex', query: {societyId:this.societyId}});
    },
    fnOneOrTwo () {
      var screenWidth = window.screen.width // 屏幕宽
      var screeHeight = window.screen.height // 屏幕高
      console.log(this.newsInfo.companyName.length > 28)
      if (screeHeight <= 768 && screenWidth <=1366 && this.newsInfo.companyName != null && this.newsInfo.companyName.length > 28) {
        this.showType = 2
        return
      } else {
        this.showType = 1
        return
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/societyArticleNews/force.vue